import React from "react";

import Section from "../shared/section";
import BlogCard from "./blog-card";
import Project1 from "../../images/expense1.png";
import Project2 from "../../images/hotel.jpg";
import Project3 from "../../images/blog4.jpg";

import "./style.scss";

const Blogs = () => {
    return (
        <Section
            id="projects2"
            title="PROJECTS"
            background="dark"
        >
            <div className="blogs-content-wrapper">
            <BlogCard
                    image={Project1}
                    title="Expense Tracker App"
                    description=".NET core, C#, SQL Server, SyncFusion Library "
                    link="https://github.com/sandesh300/Expense-Tracker-App"
                />
                <BlogCard
                    image={Project2}
                    title="Hotel Booking App"
                    description="Java, SpringBoot, MySQL, React, JWT-Auth, Spring-MVC"
                    link="https://github.com/sandesh300/Hotel-Booking-App"
                />
                <BlogCard
                    image={Project3}
                    title="Blog App"
                    description="Java, SpringBoot, MySQL, Angular, JWT-Auth, Spring-MVC "
                    link="https://github.com/sandesh300/Blog-App-Backend"
                />
            </div>
        </Section>
    );
};

export default Blogs;
